"use strict";

define('rs/global.events',['jquery', 'vertebrae'], function ($, Vertebrae) {
  $(window).on('resize', function () {
    Vertebrae.Event.trigger('window-resize', null);
  });
  $(window).on('keyup', function (ev) {
    var code = ev.which != null ? ev.which : ev.keyCode;
    Vertebrae.Event.trigger('window-keypress', code);
  });
  $(window).on('hashchange', function () {
    Vertebrae.Event.trigger('change:hash', Backbone.history.getFragment());
  });
});

